/**
 * History timeline year navigation and scroll highlighting.
 */

export function initHistoryTimeline(): void {
    const section = document.getElementById('history-section');
    const yearNav = document.querySelector<HTMLElement>('[data-year-nav]');
    const yearBtns = document.querySelectorAll<HTMLButtonElement>('[data-year-btn]');
    const timelineItems = document.querySelectorAll<HTMLElement>('[data-timeline-item]');

    if (!section || !yearNav || !timelineItems.length) {
        return;
    }

    const checkNavVisibility = (): void => {
        const rect = section.getBoundingClientRect();
        const inView = rect.top < window.innerHeight && rect.bottom > 100;

        if (inView) {
            yearNav.style.opacity = '1';
            yearNav.style.transform = 'translateY(0)';
            return;
        }

        yearNav.style.opacity = '0';
        yearNav.style.transform = 'translateY(20px)';
    };

    const updateActiveYear = (): void => {
        const scrollPos = window.scrollY + window.innerHeight / 2;
        let activeYear: string | null = null;
        let minDistance = Infinity;

        timelineItems.forEach((item) => {
            const rect = item.getBoundingClientRect();
            const itemTop = window.scrollY + rect.top;
            const distance = Math.abs(scrollPos - itemTop);

            if (distance < minDistance) {
                minDistance = distance;
                activeYear = item.dataset.year ?? null;
            }
        });

        yearBtns.forEach((btn) => {
            const btnYear = btn.dataset.yearBtn;
            if (btnYear === activeYear) {
                btn.classList.remove('bg-zinc-800', 'text-zinc-400');
                btn.classList.add('bg-hst-red', 'text-white', 'shadow-lg');
                return;
            }

            btn.classList.remove('bg-hst-red', 'text-white', 'shadow-lg');
            btn.classList.add('bg-zinc-800', 'text-zinc-400');
        });
    };

    yearBtns.forEach((btn) => {
        btn.addEventListener('click', (event) => {
            event.preventDefault();
            const year = btn.dataset.yearBtn;
            if (!year) {
                return;
            }

            const targetItem = document.querySelector<HTMLElement>(
                `[data-timeline-item][data-year="${year}"]`,
            );
            targetItem?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
    });

    let scrollScheduled = false;
    const onScroll = (): void => {
        if (scrollScheduled) {
            return;
        }

        scrollScheduled = true;
        requestAnimationFrame(() => {
            checkNavVisibility();
            updateActiveYear();
            scrollScheduled = false;
        });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    checkNavVisibility();
    updateActiveYear();
}
